import { Component, OnInit } from '@angular/core';
import { PortalDataIndicatorService } from '../../services/portal-data-indicator.service';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TabLinkModel } from '../../models/tab-link.model';
import { PortalDataIndicatorModel } from '../../models/portal-data-indicator.model';

@Component({
  selector: 'app-navigation-tabs',
  standalone: true,
  imports: [CommonModule, MatTabsModule, RouterLink, RouterLinkActive],
  templateUrl: './navigation-tabs.component.html',
  styleUrl: './navigation-tabs.component.scss',
})
export class NavigationTabsComponent implements OnInit {
  links: Array<TabLinkModel> = [];
  linksCountryPm: Array<TabLinkModel> = [];
  linksPos: Array<TabLinkModel> = [];

  portalDataIndicatorData?: PortalDataIndicatorModel = undefined;

  constructor(private portalDataIndicatorService: PortalDataIndicatorService) {}

  ngOnInit() {
    this.links = [
      {
        key: 'product',
        label: 'Product',
        url: '/dashboard/products',
        isDisabled: true,
      },
      {
        key: 'diagnosisScenario',
        label: 'Diagnosis scenarios',
        url: '/dashboard/diagnosis-scenarios',
        isDisabled: true,
      },
      {
        key: 'inStoreService',
        label: 'In-store services',
        url: '/dashboard/in-store-service',
        isDisabled: true,
      },
      {
        key: 'sample',
        label: 'Samples',
        url: '/dashboard/samples',
        isDisabled: true,
      },
      {
        key: 'gesture',
        label: 'Gestures',
        url: '/dashboard/gestures',
        isDisabled: true,
      },
    ];

    this.linksCountryPm = [
      {
        key: 'catalog',
        label: 'Catalog',
        url: '/dashboard/catalogs',
        isDisabled: true,
      },
      {
        key: 'gesture',
        label: 'Gesture',
        url: '/dashboard/gestures',
        isDisabled: true,
      },
      {
        key: 'language',
        label: 'Languages',
        url: '/dashboard/languages',
        isDisabled: true,
      },
      {
        key: 'appFeatures',
        label: 'App Features',
        url: '/dashboard/app-features',
        isDisabled: true,
      },
      {
        key: 'technicalFeatures',
        label: 'Technical Features',
        url: '/dashboard/technical-features',
        isDisabled: true,
      },
    ];

    this.linksPos = [
      {
        key: 'pos',
        label: 'Map PoS',
        url: '/dashboard/pos',
        isDisabled: true,
      },
      {
        key: 'beautyAdvisors',
        label: 'Beauty Advisors',
        url: '/dashboard/beauty-advisors',
        isDisabled: false,
      },
    ];

    this.portalDataIndicatorService.data$.subscribe(
      (portalDataIndicatorData: PortalDataIndicatorModel) => {
        if (portalDataIndicatorData['product']) {
          this.portalDataIndicatorData = portalDataIndicatorData;
        }
      }
    );

    this.portalDataIndicatorService.refreshData();
  }

  private getNbTotal(
    key: string,
    portalDataIndicatorData: PortalDataIndicatorModel
  ): number | undefined {
    if (portalDataIndicatorData[key]) {
      return (
        portalDataIndicatorData[key].nbCompleted +
        portalDataIndicatorData[key].nbNotCompleted
      );
    } else {
      return undefined;
    }
  }

  public getLabelDisplay(link: TabLinkModel) {
    if (this.portalDataIndicatorData) {
      const total = this.getNbTotal(link.key, this.portalDataIndicatorData);

      return total ? `${link.label} (${total})` : `${link.label}`;
    } else {
      return link.label;
    }
  }
}
